/* eslint-disable no-console */
import { ERROR_TIMED_OUT, ERROR_LOGIN_REQUIRED } from '@move-auth/shared';

let timeoutId;

const cleanup = iframe => {
  try {
    window.removeEventListener('message', iframe.responseHandler);
    window.document.body.removeChild(iframe);
  } catch (error) {
    /* iframe might not be there anymore */
  }
};

const createResponseHandler = ({ topic, iframe, resolve, reject, timeout }) => {
  if (timeout) {
    timeoutId = setTimeout(() => {
      clearTimeout(timeoutId);
      cleanup(iframe);
      reject(new Error(ERROR_TIMED_OUT));
    }, timeout * 1000);
  }

  const responseHandler = event => {
    // keep a reference so we can clean it up later
    // eslint-disable-next-line no-param-reassign
    iframe.responseHandler = responseHandler;

    // location.origin is not available in all browsers
    const { origin } = new URL(window.location.href);

    const {
      data: { moveAuth: payload, topic: eventTopic },
    } = event;

    // in JSDOM the event.origin is unfortunatly empty
    const originMismatch =
      event.origin !== origin && process.env.NODE_ENV !== 'test';
    const topicMismatch = eventTopic !== topic;
    const payloadEmpty = !payload;

    if (originMismatch || payloadEmpty || topicMismatch) {
      return {};
    }

    if (timeout) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    cleanup(iframe);

    if (payload.error) {
      if (payload.error === 'login_required') {
        return reject(new Error(ERROR_LOGIN_REQUIRED));
      }
      return reject(new Error(payload.error));
    }

    return resolve(payload);
  };

  return responseHandler;
};

const createIframe = (topic, hidden) => {
  const iframe = document.createElement('iframe');
  if (hidden) {
    iframe.style.display = 'none';
  } else {
    iframe.style.position = 'absolute';
    iframe.style.top = 0;
    iframe.style.left = 0;
    iframe.style.bottom = 0;
    iframe.style.right = 0;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
  }
  iframe.setAttribute('id', topic);
  iframe.setAttribute('frameborder', 0);
  return iframe;
};

export default ({ topic, url, timeout, hidden = true, parent }) =>
  new Promise((resolve, reject) => {
    const iframe = createIframe(topic, hidden);
    window.addEventListener(
      'message',
      createResponseHandler({ topic, iframe, resolve, reject, timeout })
    );
    if (parent) {
      parent.appendChild(iframe);
    } else {
      window.document.body.appendChild(iframe);
    }
    iframe.setAttribute('src', url);
  });
